import { useQueryClient } from '@tanstack/react-query'
import {
  ORG_ACKNOWLEDGEMENTS,
  orgQueryKeys,
} from 'src/queries/queries.constants'
import {
  ExtendBaseQueryOptions,
  MutationMethod,
  useExtendMutation,
  UseExtendMutationVariablesBody,
  useExtendQuery,
} from 'src/queries/queries.utils'

interface OrganizationAcknowledgementsOptions
  extends ExtendBaseQueryOptions<GetOrgAcknowledgementsStatusResponse> {}

interface AcknowledgementBody {
  acknowledged: boolean
}

export interface GetOrgAcknowledgementsStatusResponse {
  acknowledgement: AcknowledgementBody
}

export const useQueryOrganizationAcknowledgements = ({
  ...rest
}: OrganizationAcknowledgementsOptions) => {
  return useExtendQuery<GetOrgAcknowledgementsStatusResponse>({
    queryKey: orgQueryKeys.acknowledged(),
    queryUrl: () => `acknowledgements?type=OWNER_ADMIN_CARD_MANAGER_MIGRATION`,
    staleTime: 1000 * 60,
    ...rest,
  })
}
interface PostSendOrganizationAcknowledgements
  extends UseExtendMutationVariablesBody {}

export const usePostSendOrgRolesAcknowledgement = () => {
  const queryClient = useQueryClient()
  return useExtendMutation<
    PostSendOrganizationAcknowledgements,
    PostSendOrganizationAcknowledgements
  >(MutationMethod.POST, {
    mutationUrl: () => `/acknowledgements`,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ORG_ACKNOWLEDGEMENTS] })
    },
  })
}
